import React from 'react'
import { CircularProgress } from '@material-ui/core'
import { Button, OtpInput } from 'src/components'
import { useStyles } from './styles'
import { usePhoneConfirmation } from './hooks/usePhoneConfirmation'

export const ConfirmPhoneVerification: React.FC = () => {
  const style = useStyles()
  const { otp, codeSent, isLoading, phoneRegistered, isSending, sendCode, resendCode, submitCode } =
    usePhoneConfirmation()

  return (
    <div className={style.confirmPhoneContainer}>
      <div className={style.confirmPhoneForm}>
        <div className={style.confirmPhoneTitleWrapper}>
          <h1>CONGADO</h1>
        </div>

        <div className={style.confirmPhoneInfoWrapper}>
          <h2>Confirmação de Telefone</h2>
          <p className={style.confirmPhoneDescription}>
            Para acessar o sistema, é necessário confirmar seu telefone.
          </p>
          {phoneRegistered && (
            <p className={style.confirmPhonePhone}>
              {codeSent ? 'Código enviado para: ' : 'Enviaremos um código para: '}
              <strong>{phoneRegistered}</strong>
            </p>
          )}
        </div>

        {!codeSent ? (
          <Button
            onClick={sendCode}
            className='confirm-phone__button'
            disabled={isSending}
            style={{ width: '100%', maxWidth: 532 }}
            isLoading={isLoading}
          >
            Enviar Código
          </Button>
        ) : (
          <form onSubmit={submitCode} style={{ width: '100%', maxWidth: 532 }}>
            <div className={style.confirmPhoneCodeWrapper}>
              <label>Informe abaixo o código que você recebeu no seu telefone:</label>
              <OtpInput
                code={otp.code}
                disabled={isLoading}
                onChange={otp.handleChange}
                onKeyDown={otp.handleKeyDown}
                onPaste={otp.handlePaste}
                setRef={otp.setRef}
              />
            </div>

            <div className={style.confirmPhoneResend}>
              <button
                type='button'
                onClick={resendCode}
                disabled={isLoading}
                className={style.confirmPhoneResendButton}
              >
                {isSending ? (
                  <>
                    <CircularProgress size={16} style={{ color: '#784A42', marginRight: 8 }} />
                    Enviando...
                  </>
                ) : (
                  'Enviar novo código'
                )}
              </button>
            </div>

            <Button type='submit' className='confirm-phone__button' disabled={isLoading} isLoading={isLoading}>
              Confirmar Telefone
            </Button>
          </form>
        )}
      </div>

      <div className={style.confirmPhoneImageSide}></div>
    </div>
  )
}
